/** Sort-option id that reveals group-by, value order, and in-group sort. */
export const GRID_SETTINGS_CUSTOM_SORT_ID = 'custom';

/** MUI single-grouping-column field. Used when Custom grouping is applied. */
export const GRID_SETTINGS_GROUPING_COLUMN_FIELD = '__row_group_by_columns_group__';

export const EMPTY_GRID_GROUPING_MODEL: string[] = [];
export const EMPTY_GRID_SETTINGS_OPTIONS: { id: string; label: string }[] = [];
